const ENV = require('../_env');
const g = window[ENV.projectName] = window[ENV.projectName] || {};

import Mesh from './_unshiftWebGL/objects/Mesh';
import Material from './_unshiftWebGL/core/Material';
import Texture from './_unshiftWebGL/textures/Texture';

export default class Planes extends Mesh {
  constructor(gl, baseGeometry, camera, dir, blockNoiseTexture) {
    // material
    const material = new Material({
      vertexShader: require('./_glsl/planes.vert'),
      fragmentShader: require('./_glsl/planes.frag'),
      depthTest: false,
      transparent: true,
      uniforms: {
        texture       : { type: 'texture'          , value: null  },
        isLoaded      : { type: 'uniform1f'        , value: 1     },
        animationValue: { type: 'uniform1f'        , value: 0     },
        scale         : { type: 'uniform1f'        , value: 1     },
        offsetY       : { type: 'uniform1f'        , value: 0     },
        scaleY        : { type: 'uniform1f'        , value: 1     },
        numCols       : { type: 'uniform1f'        , value: 0     },
        numRows       : { type: 'uniform1f'        , value: 0     },
        iNumCols      : { type: 'uniform1f'        , value: 0     },
        iNumRows      : { type: 'uniform1f'        , value: 0     },
        numInstances  : { type: 'uniform1f'        , value: 0     },
        height        : { type: 'uniform1f'        , value: 0     },
        isLayoutL     : { type: 'uniform1f'        , value: 0     },
        dir           : { type: 'uniform1f'        , value: dir   },
        modelMatrix   : { type: 'uniformMatrix4fv' , value: null  },
        vpMatrix      : { type: 'uniformMatrix4fv' , value: null  },
        color      : { type: 'uniform3f'           , value: [196/255, 237/255, 255/255]  },

        glitchTex  : { type: 'texture'  , value: blockNoiseTexture },
        glitchValue: { type: 'uniform1f', value: 0 },
      }
    });

    super(baseGeometry, material);

    this.gl = gl;
    this.camera = camera;
    this.material.uniforms.modelMatrix.value = this.modelMatrix;
  }

  async init(texturesData, textureLabel, bufferGeometryBuilders, layoutMode) {
    this.texturesData = texturesData;
    this.textureLabel = textureLabel;
    this.layoutMode = layoutMode;
    this.bufferGeometryBuilders = bufferGeometryBuilders;

    this.textureData = this.texturesData[this.layoutMode];

    // texture
    this.texture = new Texture();
    this.texture.minFilter = 'LINEAR';
    this.texture.magFilter = 'LINEAR';
    this.texture.wrapS = 'MIRRORED_REPEAT';
    this.texture.wrapT = 'MIRRORED_REPEAT';
    this.texture.mipmap = false;
    this.textureData.texture = this.texture;

    await this.texture.load(this.textureData[this.textureLabel]);
    this.material.uniforms.texture.value = this.texture;

    this.geometry = this.bufferGeometryBuilders[this.layoutMode].getGeometry();
  }

  async onResize(layoutMode, width, height, devicePixelRatio, vpMatrix, scale, offsetY, numCols, numRows) {
    this.layoutMode = layoutMode;
    this.width = width;
    this.height = height;
    this.devicePixelRatio = devicePixelRatio;

    // swap texture
    if(layoutMode) {

      if(this.layoutMode !== layoutMode) {
        this.layoutMode = layoutMode;
        this.textureData = this.texturesData[this.layoutMode];
        this.geometry = this.bufferGeometryBuilders[this.layoutMode].getGeometry();
        this.isUpdated = true;

        if(this.textureData.texture && this.textureData.texture.isLoaded) {
          this.texture = this.textureData.texture;
        } else {
          this.texture = new Texture();
          this.textureData.texture = this.texture;
          this.material.uniforms.isLoaded.value = 0;
          await this.texture.load(this.textureData[this.textureLabel]);
          this.texture.setGLContext(this.gl);
          this.material.uniforms.isLoaded.value = 1;
        }

        this.material.uniforms.texture.value = this.texture;
      }
    }

    this.material.uniforms.vpMatrix.value = vpMatrix;
    this.material.uniforms.scale.value = scale;
    this.material.uniforms.offsetY.value = offsetY;
    this.material.uniforms.numCols.value = numCols;
    this.material.uniforms.numRows.value = numRows;
    this.material.uniforms.iNumCols.value = 1 / numCols;
    this.material.uniforms.iNumRows.value = 1 / numRows;
    this.material.uniforms.numInstances.value = numCols * numRows;
    this.material.uniforms.height.value = height;
    this.material.uniforms.isLayoutL.value = layoutMode == 'l'? 1: 0;
  }
};
